export const messages = {
  appUpdate: {
    available: "È disponibile una nuova versione dell'app.",
    updateNow: 'Aggiorna ora',
    dismiss: 'Chiudi',
    dismissLabel: 'Chiudi avviso di aggiornamento',
  },
  undo: {
    cancel: 'Annulla',
  },
};

export function useMessages() {
  return messages;
}
